import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { AlertTriangle } from "lucide-react";
import { saucesService } from "../../../shared/services";
import React from "react";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { selectproductWarehousesRefreshTable } from "../../../redux/selectors/productWarehouses.selectors";
import { useSelector } from "react-redux";
import { refreshTableAddressesUser } from "../../../redux";

const { confirm } = Modal;

export const useRemoveSauce = () => {
  const [tableProps, setTableProps] = React.useState<TableProperties>();
  const dispatch = useAppDispatch();
  const isproductWarehousesRefreshTable= useSelector(
    selectproductWarehousesRefreshTable
  );
  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: (
        <div style={{ fontSize: "18px", fontWeight: 600, color: "#2d3748", marginBottom: "8px" }}>
          ¿Eliminar salsa?
        </div>
      ),
      icon: (
        <div style={{ 
          width: "48px", 
          height: "48px", 
          borderRadius: "12px", 
          backgroundColor: "#fff3e6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px"
        }}>
          <AlertTriangle size={24} color="#ff6b00" />
        </div>
      ),
      content: (
        <div style={{ color: "#718096", fontSize: "14px", lineHeight: "1.6" }}>
          Estás a punto de eliminar <strong style={{ color: "#2d3748" }}>"{val}"</strong> (ID: {valId}).
          <br /><br />
          Esta acción no se puede deshacer. ¿Deseas continuar?
        </div>
      ),
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      centered: true,
      okButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      cancelButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      async onOk() {
        await saucesService.remove(valId)
          .then(() => {
            notify.success(
              `Salsa "${val}" eliminada correctamente`
            );
            tableProps?.refresh();

          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isproductWarehousesRefreshTable) {
      tableProps?.refresh();
      dispatch(refreshTableAddressesUser(false));
    }
  }, [isproductWarehousesRefreshTable]);

  return {
    showDeleteConfirm,
    setTableProps
  };
};
